'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-list.routes';

export class SurveyListComponent {
  constructor(Auth, SurveysService, dialogs, $uibModal, $stateParams, prompt) {
    'ngInject';
    this.SurveysService = SurveysService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;
    this.prompt = prompt;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.formName = $stateParams.name;

    this.SurveysService.query(data => {
      this.data = data;
    }, err => {
      console.log("Could not retrieve surveys.")
    })
  }

  delete(survey) {
    var that = this;

    var surveyText = "<br/><br/><p><b>"+ survey.name + "</b></p>";

    let callout = `<div class="bs-callout bs-callout-danger">
      <h4>Warning!</h4>
      When you delete this survey, all user responses won't be accessible anymore. <b>This cannot be undone!</b>
    </div>`;

    var dlg = this.dialogs.confirm("Delete Surveys?", "Do you really want to delete the survey?" + surveyText + callout);
    dlg.result.then(() => {

      that.prompt({
        title: 'Confirm deletion of Survey',
        message: 'To finally delete it, please enter the survey name below:',
        input: true,
        label: '',
        value: ''
      }).then(name => {

        if (survey.name == name) {
          // OK delete it
          that.SurveysService.delete({id: survey._id},
            () => {
              that.data = that.data.filter(function( obj ) {
                return obj._id !== survey._id;
              });
            },
            err => {
              alert("Could not delete survey");
            });
        } else {
          that.dialogs.notify("Name doesn't match", "The name doesn't match the survey you are about to delete.")
        }

      }, () => {
        // Cancel
      });

      });
  }

}

export default angular.module('conduu.survey.list', [uiRouter])
  .config(routes)
  .component('surveyList', {
    template: require('./survey-list.html'),
    controller: SurveyListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/list/survey-list.component.js